import { axiosClient } from '@/api/axios'
import type {
  Organization,
  CreateOrganizationPayload,
  UpdateOrganizationPayload,
} from './types'


export const getOrganization = async (id: string) => {
  return axiosClient.get<Organization>(`/organizations/${id}`)
}

export const createOrganization = async (payload: CreateOrganizationPayload) => {
  return axiosClient.post<Organization>('/organizations', payload)
}

export const updateOrganization = async (id: string, payload: UpdateOrganizationPayload) => {
  return axiosClient.patch<Organization>(`/organizations/${id}`, payload)
}


